import 'css-chunk:../../src/components/form/form-text/index.module.scss';export default {
  "input": "_input_3nwk2_1",
  "outlined": "_outlined_3nwk2_21"
};